/*
 * @Author: linbin@leedarson.com
 * @Date: 2019-07-29 10:02:37
 * Copyright © Leedarson. All rights reserved.
 */

import { useEffect, useRef } from 'react';

/**
 * 重复执行，支持暂停
 * @param {Function} callback
 * @param {Number} delay - 延迟毫秒，如果null，表示暂停执行
 */
const useInterval = (callback, delay) => {
  const ref = useRef();

  // 保存新回调，每次组件更新都会执行
  useEffect(() => {
    ref.current = callback; // 动态
  });

  // 初始化和卸载
  useEffect(() => {
    const tick = () => {
      ref.current();
    };

    let id = 0;

    // 设置计时器
    if (delay > 0) {
      id = setInterval(tick, delay);
    }

    // 卸载清除
    return () => {
      clearInterval(id);
    };
  }, [delay]);
};

export default useInterval;
